[
  {
    "url": "/_next/static/media/favicon.75d76903.ico",
    "revision": null
  },
  {
    "url": "/_next/static/media/apple-icon.11b148db.png",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0030379241536d5d.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/ff1a16fafef87110.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/fd1ecd24a7a7050a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/fb145a5df3b1cf15.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/f481a194a34724b9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/f1ec59aeda923cff.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/ed753321c8407b02.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/e303078feddb2271.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/ccf03635d8170055.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/c40bc1f91b3326ac.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/b938a32e11f96983.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/aa8d9d8212172ba5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/a6dad97d9634a72d.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/a44cb61b4bf3cb02.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/98c63146b045b882.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/6f16b21349522959.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/66a8c16702b8a250.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/657f0acf04e90dcb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/641da4851b78d47d.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/5e1914806bda545e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/5cebfe5cab0a1b28.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/59f3ff30c45ef6d3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/516c2e937eb4a321.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/4b159df27413670e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/42c251b3a244e88f.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3e3b214d091e34b3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/385b358040b9acb5.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/23d04a4212131293.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/046569f8fe25685a.js",
    "revision": null
  },
  {
    "url": "/_next/static/Px1GiiocLwDM8vaQsBBGk/_ssgManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/Px1GiiocLwDM8vaQsBBGk/_clientMiddlewareManifest.json",
    "revision": null
  },
  {
    "url": "/_next/static/Px1GiiocLwDM8vaQsBBGk/_buildManifest.js",
    "revision": null
  },
  {
    "url": "/sw.js",
    "revision": "65e54c1e64062259c04122b5c3dd30b1"
  },
  {
    "url": "/sitemap.xml",
    "revision": "b989d03fea0d29fb6291576318b84b20"
  },
  {
    "url": "/sitemap-0.xml",
    "revision": "f71ba88e5138f91c25d55a1d9640df86"
  },
  {
    "url": "/screenshot-wide.png",
    "revision": "c6f0f9bc2f57bdc39e10a6bc90eabe10"
  },
  {
    "url": "/screenshot-narrow.png",
    "revision": "97bca09f169689937401d931dfec3c13"
  },
  {
    "url": "/og.svg",
    "revision": "453dddb432d27a4541ea9f839d0e0710"
  },
  {
    "url": "/manifest.json",
    "revision": "887e6b5c32eacf5c4bdf9327a897c1ae"
  },
  {
    "url": "/logo-icon.svg",
    "revision": "24d1fb5d362162a4d64a654093ddb285"
  },
  {
    "url": "/llms.txt",
    "revision": "cd98d411bb42512b37b0e12e7b173715"
  },
  {
    "url": "/favicon.svg",
    "revision": "702ed7bdd6e988176ea3143949d07269"
  },
  {
    "url": "/favicon.ico",
    "revision": "d3e121a865d4483546be217c6bbe816c"
  },
  {
    "url": "/blog-manifest.json",
    "revision": "ca4725c5da06c8602b1efecbddc6a5e3"
  },
  {
    "url": "/539e82c0b6e7b8d800b382ce42b473cf.txt",
    "revision": "cedfb616caa3c0f287abc611f7657bcb"
  }
]